import { action, makeAutoObservable } from 'mobx'

class SideNav {
  collapsable = false
  isOpen = true

  constructor() {
    makeAutoObservable(this, { setIsOpen: action.bound, setCollapsable: action.bound })
  }

  setCollapsable(collapsable: boolean) {
    this.collapsable = collapsable
  }

  setIsOpen(isOpen: boolean) {
    this.isOpen = isOpen
  }
}

export default new SideNav()
